import { combineReducers } from 'redux';
import show_attendance from './show-attendance';
import attendance_list from './attendance-list';
import firm_info from './firm-info';
import meeting_materials from './meeting-materials';
import roll_call_status from './roll-call-status';
import all_companies_for_email from './show-all-companies';
import email_error from './email-error';
import committee_participant from './committee-participant';
import expired_token from './expired-token';

export default combineReducers( {
	                                show_attendance,
	                                attendance_list,
	                                firm_info,
	                                meeting_materials,
	                                roll_call_status,
	                                committee_participant,
	                                all_companies_for_email,
	                                email_error,
																	expired_token,
                                } );